import { Spin } from 'antd';
import { Suspense, lazy } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import Layout from '../../../components/Layout';
import Menu from '../../../components/Layout/Menu';

const UsersCreateContent = lazy(() => import('../../../components/Pages/Users/Create'));

export default function UsersCreate(): JSX.Element | null {
  document.title = `${process.env.REACT_APP_TITLE}: Users Create page`;

  return (
    <Layout LeftMenu={Menu} transparent>
      <Suspense fallback={<Spin spinning indicator={<LoadingOutlined spin />} />}>
        <UsersCreateContent />
      </Suspense>
    </Layout>
  );
}
